module.exports = __webpack_public_path__ + "img/food2.f549130e.jpg";